import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import { LocalStorage } from 'quasar'
import routes from './routes'
import { isViewer, VIEWER_BLOCKED_PATHS } from 'src/utils/auth'
import { openViewerRestricted } from 'src/stores/viewerGuard'

const PUBLIC_PATHS = ['/', '/signin', '/signup', '/setup']

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  const AUTH_PATHS = ['/signin', '/signup', '/']

  Router.beforeEach((to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const isPublic = PUBLIC_PATHS.includes(to.path)
    const token = LocalStorage.getItem('token')
    if (token && AUTH_PATHS.includes(to.path)) {
      next('/user/dashboard')
    } else if (!isPublic && !token) {
      next('/signin')
    } else if (token && isViewer() && VIEWER_BLOCKED_PATHS.includes(to.path)) {
      // 열람 전용(viewer): 업로드/DB 가져오기/분석 추가 화면 진입 차단 + 이유 안내(권한 신청 유도)
      openViewerRestricted('데이터 업로드·분석 실행')
      next('/user/dashboard')
    } else {
      next()
    }
  })

  return Router
})
